(function () {
  function formatWeightWithUnit(grams) {
    if (!grams || grams <= 0) return "";
    if (grams >= 1000) return (grams / 1000).toLocaleString('pt-BR') + " kg";
    return grams.toLocaleString('pt-BR') + " g";
  }

  function getVariantsFromWindow() {
    const all = window.__PRODUCT_VARIANTS__ || {};
    const productId = Object.keys(all)[0];
    return productId ? all[productId] : null;
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return Number(idInput.value);

    const select = form.querySelector('select[name="id"]');
    if (select && select.value) return Number(select.value);

    return null;
  }

  function updateWeight() {
    const weightValueEl = document.getElementById('ProductWeightValue');
    if (!weightValueEl) return;

    const wrapper = weightValueEl.closest('.product-weight');
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const variants = getVariantsFromWindow();
    if (!variants || !variants.length) return;

    const variantId = getSelectedVariantId(form);
    if (!variantId) return;

    const v = variants.find(x => x.id === variantId);
    if (!v) return;

    const text = formatWeightWithUnit(v.weight);

    if (text) {
      weightValueEl.textContent = text;
      if (wrapper) wrapper.style.display = "";
    } else {
      weightValueEl.textContent = "";
      if (wrapper) wrapper.style.display = "none";
    }
  }

  function bind() {
    updateWeight();

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const triggerUpdate = () => requestAnimationFrame(updateWeight);

    form.addEventListener('change', triggerUpdate);
    form.addEventListener('click', triggerUpdate);

    document.addEventListener('variant:change', triggerUpdate);
    document.addEventListener('product:variant-change', triggerUpdate);
  }

  document.addEventListener('DOMContentLoaded', bind);
})();
